// NEURACOM i18n — locale: it
// Auto-generated from translations.js refactor (iteration 25).
// Edit by namespace section. Keep keys in sync with en.js + it.js + pl.js.
const it = {
  common: {
    brand: "NEURACOM",
    brand_by: "by TelcaVoIP",
    get_started: "Inizia ora",
    sign_in: "Accedi",
    sign_up: "Registrati",
    sign_out: "Esci",
    dashboard: "Dashboard",
    pricing: "Prezzi",
    features: "Funzionalità",
    contact: "Contatti",
    loading: "Caricamento...",
    cancel: "Annulla",
    save: "Salva",
    delete: "Elimina",
    try_free: "Prova gratis",
    upgrade: "Aggiorna piano",
    learn_more: "Scopri di più",
    coming_soon: "Prossimamente",
    partner_program: "Programma Partner",
    close: "Chiudi",
  },
  pwa: {
    install_title: "Installa NEURACOM",
    install_desc: "Aggiungi NEURACOM alla schermata Home — accesso istantaneo, funziona anche offline.",
    install_cta: "Installa",
    install_later: "Più tardi",
    install_ios_title: "Installa NEURACOM su iPhone",
    install_ios_step1: "Tocca",
    install_ios_step2: "poi",
    install_ios_step3: "Aggiungi a Home",
    update_title: "Nuova versione disponibile",
    update_desc: "Ricarica ora per ottenere le ultime funzionalità e correzioni.",
    update_reload: "Ricarica",
    update_later: "Più tardi",
    offline_badge: "Offline",
    offline_toast: "Sei offline — alcune funzioni potrebbero non funzionare.",
    online_toast: "Di nuovo online.",
  },
  download: {
    pretitle: "Installa come app",
    title: "Porta NEURACOM nel tuo telefono",
    subtitle_desktop: "Inquadra il codice QR con la fotocamera del telefono. L'app si installa in 5 secondi — niente App Store, niente Play Store, nessuna attesa per la revisione.",
    subtitle_mobile: "Aggiungi NEURACOM alla schermata Home. Tocca il pulsante qui sotto e l'app si installa in 5 secondi.",
    chip_no_store: "Niente App Store",
    chip_offline: "Funziona offline",
    chip_native: "Esperienza nativa",
    chip_size: "Meno di 1 MB",
    install_now: "Installa NEURACOM",
    no_store_note: "Installazione diretta · senza revisione · accesso immediato",
    desktop_note: "Una volta installata, riceverai notifiche push, input vocale che funziona offline e tempi di caricamento più veloci.",
    qr_caption_desktop: "Punta la fotocamera qui",
    qr_caption_mobile: "Oppure scansiona da un altro dispositivo",
    installed_badge: "Già installata",
    installed_title: "Sei a posto — NEURACOM è sulla tua schermata Home.",
    installed_desc: "Tocca l'icona in qualsiasi momento per avviare l'app.",
    ios_title: "Installa su iPhone — 3 passi rapidi",
    ios_step_1: "Tocca il pulsante Condividi in fondo a Safari",
    ios_step_2: "Scorri verso il basso e tocca",
    ios_add_to_home: "Aggiungi a Home",
    ios_step_3: "Conferma con 'Aggiungi' in alto a destra",
  },
  landing: {
    hero_pretitle: "Piattaforma AI per aziende europee",
    hero_title: "Costruisci con l'AI. Pubblica ovunque.",
    hero_subtitle:
      "Chat multi-modello, generazione immagini e AI code builder — tutto in uno spazio sicuro e multilingua. Powered by NEURACOM, by TelcaVoIP.",
    hero_cta_primary: "Inizia gratis — senza carta",
    hero_cta_secondary: "Vedi i prezzi",
    stat_models: "Modelli AI",
    stat_languages: "Lingue",
    stat_uptime: "Uptime SLA",
    stat_rulings: "Massime curate",
    stat_gdpr_compact: "Hosted UE, GDPR",
    stat_kb: "Note private",
    stat_gdpr: "100% conforme",
    hero_legal_chip: "Cerchi Legal Pro?",
    legal_pretitle: "Legal Pro · Per avvocati e DPO",
    legal_title: "Il primo assistente AI legale italiano addestrato su Cassazione + CGUE.",
    legal_subtitle: "Smettila di copiare risposte da ChatGPT nei tuoi atti. NEURACOM Legal Pro ragiona su 103 massime di legittimità curate, cita la tua KB privata e scrive in vero linguaggio giuridico italiano.",
    legal_feat_jurisprudence_title: "103 massime di legittimità",
    legal_feat_jurisprudence_desc: "Giurisprudenza curata di Cassazione (SS.UU. + Sezioni) e CGUE, ricercabile con BM25 nativo + auto-cite durante la chat.",
    legal_feat_knowledge_base_title: "Il tuo cervello giuridico privato",
    legal_feat_knowledge_base_desc: "Salva qualsiasi massima, risposta AI o nota nella tua KB cifrata. Pinna, cerca, tagga — il tuo know-how cresce a ogni causa.",
    legal_feat_auto_cite_title: "Citazioni ambient",
    legal_feat_auto_cite_desc: "Mentre digiti, NEURACOM ti propone le 3 note più rilevanti dalla tua KB. Modalità Auto-KB le inietta automaticamente — zero clic.",
    legal_feat_gdpr_title: "Hosted UE, GDPR by design",
    legal_feat_gdpr_desc: "Dati elaborati in UE, isolati per account, mai usati per addestrare modelli esterni. Tutele art. 22 GDPR incluse.",
    legal_workflow_pretitle: "Come funziona Legal Pro",
    legal_workflow_title: "Da ricerca a brief pronto, in pochi minuti.",
    legal_step_1_title: "Salva massime con 1 clic",
    legal_step_1_desc: "Sfoglia le 103 massime curate IT/UE o carica i tuoi PDF. Pinna i principi che riusi più spesso.",
    legal_step_2_title: "Chatta in Modalità Legale",
    legal_step_2_desc: "Attiva la Modalità Legale. L'AI cita automaticamente massime rilevanti dal database — e dalla tua KB privata.",
    legal_step_3_title: "Citazioni verbatim, niente allucinazioni",
    legal_step_3_desc: "Ogni citazione è ancorata a una vera massima o a una tua nota. Le risposte includono Corte, numero sentenza e data.",
    legal_step_4_title: "Esporta per il tuo atto",
    legal_step_4_desc: "Copia la risposta nel tuo atto o memoria — il linguaggio è già in registro formale giuridico italiano.",
    legal_quote: "\"Prima passavo 40 minuti su Italgiure per trovare la massima giusta. Con NEURACOM ho una bozza con 3 citazioni verificate in 90 secondi.\"",
    legal_quote_author: "Avv. M. (Studio Legale, Milano)",
    legal_quote_role: "Diritto civile e commerciale · Utente Legal Pro",
    legal_use_contracts: "Contratti",
    legal_use_litigation: "Contenzioso",
    legal_use_gdpr: "GDPR & Privacy",
    legal_use_labor: "Diritto del lavoro",
    legal_use_tax: "Tributario",
    legal_use_real_estate: "Diritto immobiliare",
    legal_price_unit: "/ mese · cancelli quando vuoi",
    legal_price_note: "Include Claude Opus 4.8, 1.000 msg chat/mese, 100 PDF caricati, note KB illimitate.",
    legal_cta_primary: "Inizia prova Legal Pro",
    legal_cta_secondary: "Confronta tutti i piani",
    features_title: "Un workspace. Ogni task AI.",
    features_subtitle:
      "Smetti di saltare da una scheda all'altra. NEURACOM ti dà Claude, GPT, Gemini, generazione immagini e un AI code builder in un'unica piattaforma brandizzata.",
    feat_chat_title: "Chat AI Multi-modello",
    feat_chat_desc:
      "Cambia tra Claude Sonnet 4.5, GPT-5.2 e Gemini 3 Flash in una sola chat. Scegli il cervello giusto per ogni task.",
    feat_image_title: "Image Generation Studio",
    feat_image_desc:
      "Genera immagini straordinarie con Gemini Nano Banana e OpenAI GPT-Image-1. Marketing, mockup, social.",
    feat_code_title: "AI Code Builder",
    feat_code_desc:
      "Descrivi un'app nella tua lingua. Ottieni un file HTML/CSS/JS completo con preview live e download ZIP.",
    feat_quotas_title: "Quote trasparenti",
    feat_quotas_desc:
      "Limiti mensili chiari per piano. Niente sorprese in fattura. Aggiorna solo se serve.",
    feat_secure_title: "Privacy a livello UE",
    feat_secure_desc:
      "I tuoi dati restano tuoi. Crittografati in transito e a riposo. GDPR-friendly by design.",
    feat_multilang_title: "UI trilingue",
    feat_multilang_desc:
      "Italiano, inglese, polacco — auto-rilevati dal browser. Zero configurazione.",
    voice_pretitle: "Novità — input vocale",
    voice_title: "Parla con NEURACOM. Nella tua lingua.",
    voice_subtitle:
      "Tocca il microfono, detta il tuo prompt e lascia che OpenAI Whisper trasformi la tua voce in testo perfetto — automaticamente. Senza setup, senza app, senza strumenti di trascrizione.",
    voice_bullet_languages: "Riconosce italiano, inglese e polacco automaticamente — nessuna selezione manuale",
    voice_bullet_fast: "Whisper-1 elabora in meno di 3 secondi una clip tipica da 30 secondi",
    voice_bullet_private: "L'audio viene processato in modo transitorio, mai memorizzato — GDPR-friendly",
    voice_cta_primary: "Prova la chat vocale gratis",
    voice_cta_note: "Nessuna carta di credito richiesta",
    voice_transcript_label: "Trascrizione live",
    voice_transcript_example: "“Scrivi un'email di aggiornamento prodotto in tono amichevole, max un paragrafo.”",
    cta_title: "Pronto a costruire con l'AI?",
    cta_subtitle:
      "Inizia gratis oggi. Aggiorna solo quando lanci qualcosa di vero.",
    cta_button: "Crea il tuo account",
  },
  pricing: {
    title: "Prezzi semplici e trasparenti",
    subtitle: "Scegli il piano adatto al tuo uso. Cancella in qualsiasi momento.",
    per_month: "/mese",
    most_popular: "PIÙ POPOLARE",
    cta_free: "Inizia gratis",
    cta_paid: "Sottoscrivi",
    current_plan: "Piano attivo",
    cycle_monthly: "Mensile",
    cycle_annual: "Annuale",
    cycle_save_badge: "Risparmia 2 mesi",
    annual_total: "€{total}/anno — risparmi €{saved} rispetto al mensile",
    promo_first_month_note: "Solo il primo mese — €{price}/mese a partire dal secondo",
    promo_cleared_annual: "I codici promo valgono solo per il mensile — il piano annuale include già lo sconto.",
    err_PROMO_NOT_VALID_FOR_ANNUAL: "I codici promo valgono solo per il mensile. Passa al mensile per usare un promo.",
    free_name: "Free",
    free_price: "€0",
    free_tagline: "Prova la piattaforma",
    starter_name: "Starter",
    starter_tagline: "Per creatori singoli",
    pro_name: "Pro",
    pro_tagline: "Per freelance e team piccoli",
    business_name: "Business",
    business_tagline: "Per agenzie e aziende",
    legal_specialized: "Verticale specializzato",
    legal_pro_name: "Legal Pro",
    legal_pro_tagline: "Per avvocati, consulenti e DPO. Assistente specializzato in diritto italiano ed UE, con accesso prioritario al modello più potente per ragionamento giuridico.",
    legal_pro_target: "Pensato per: avvocati, commercialisti, HR manager, DPO, in-house legal counsel.",
    legal_pro_cta: "Passa a Legal Pro",
    legal_pro_feature_quota: "8.000 messaggi AI, 300 immagini, 100 progetti code, 50 PDF Q&A al mese",
    legal_pro_feature_opus: "Accesso prioritario a Claude Opus 4.8 e Fable 5 (beta) — 1M context per ragionamento giuridico",
    legal_pro_feature_default_on: "Modalità Legale attiva di default su ogni nuova chat",
    legal_pro_feature_templates: "7 template legali pre-compilati (NDA, informativa GDPR, contratti consulenza, T&C e-commerce…)",
    legal_pro_feature_rag: "Analisi automatica clausola-per-clausola dei contratti caricati (PDF Q&A) + 103 massime curate",
    legal_pro_feature_kb: "Knowledge Base Legale Personale con citazioni ambient Auto-KB",
    legal_pro_feature_priority: "Supporto e risposte prioritarie",
    feat_msgs: "{n} messaggi chat AI/mese",
    feat_imgs: "{n} immagini generate/mese",
    feat_code: "{n} progetti code/mese",
    feat_models: "Multi-modello: Claude, GPT, Gemini",
    feat_priority: "Supporto prioritario",
    feat_email: "Supporto email",
    feat_history: "Storico completo conservato",
    feat_api: "Accesso API (solo Business)",
    promo_label: "Hai un codice promo?",
    promo_placeholder: "LAUNCH2026",
    promo_apply: "Applica",
    promo_clear: "Rimuovi",
    promo_applied: "✓ Promo applicata — Pro primo mese a €{price}",
    promo_banner_title: "🚀 Promo di lancio — primo mese Pro a €9",
    promo_banner_subtitle: "Usa il codice {code}. Limitato ai primi 100 iscritti ({remaining} disponibili).",
    err_PROMO_INVALID_CODE: "Codice promo non valido.",
    err_PROMO_PLAN_MISMATCH: "Questo codice vale solo per il piano Pro.",
    err_PROMO_EXHAUSTED: "Spiacenti — questa promo è esaurita.",
  },
  auth: {
    welcome_back: "Bentornato",
    welcome_new: "Crea il tuo account NEURACOM",
    email_label: "Email",
    password_label: "Password",
    name_label: "Il tuo nome (opzionale)",
    sign_in_btn: "Accedi",
    sign_up_btn: "Crea account",
    google_btn: "Continua con Google",
    have_account: "Hai già un account?",
    no_account: "Non hai ancora un account?",
    or_divider: "oppure",
    password_hint: "Minimo 8 caratteri",
    err_AUTH_INVALID_CREDENTIALS: "Email o password non validi.",
    err_AUTH_EMAIL_ALREADY_REGISTERED: "Questa email è già registrata.",
    err_AUTH_EMERGENT_NO_EMAIL: "Login Google fallito — email non restituita.",
    err_AUTH_EMERGENT_INVALID_SESSION: "Sessione Google scaduta.",
    err_AUTH_NOT_AUTHENTICATED: "Accedi per continuare.",
    err_AUTH_INVALID_TOKEN: "La tua sessione è scaduta. Accedi di nuovo.",
    err_UNKNOWN_ERROR: "Errore sconosciuto. Riprova.",
  },
  dashboard: {
    welcome: "Bentornato",
    current_plan: "Piano attivo",
    usage_overview: "Utilizzo del periodo",
    messages_used: "Messaggi chat",
    images_used: "Immagini generate",
    code_used: "Progetti code",
    quick_actions: "Azioni rapide",
    action_chat: "Inizia una nuova chat",
    action_image: "Genera un'immagine",
    action_code: "Costruisci con l'AI",
    recent_chats: "Conversazioni recenti",
    recent_images: "Immagini recenti",
    no_activity: "Nessuna attività ancora. Inizia sopra.",
    upgrade_cta: "Passa a {plan} per più capacità",
    tier_free: "Free",
    tier_starter: "Starter",
    tier_pro: "Pro",
    tier_business: "Business",
  },
  chat: {
    new_chat: "Nuova chat",
    conversations: "Conversazioni",
    placeholder: "Chiedi qualsiasi cosa…",
    send: "Invia",
    model: "Modello",
    thinking: "Sto pensando…",
    model_claude: "Claude Sonnet 4.5",
    model_gpt: "GPT-5.2",
    model_gemini: "Gemini 3 Flash",
    group_claude: "Anthropic — Claude",
    group_openai: "OpenAI",
    group_gemini: "Google — Gemini",
    model_claude_sonnet: "Claude Sonnet 4.5 — Bilanciato",
    model_claude_sonnet_46: "Claude Sonnet 4.6 — Bilanciato top",
    model_claude_opus_48: "Claude Opus 4.8 — Reasoning flagship",
    model_claude_fable_5: "Claude Fable 5 — 1M context (beta)",
    model_fallback_toast: "{from} non ancora abilitato — uso {to} al suo posto",
    model_claude_haiku: "Claude Haiku 4.5 — Rapido",
    model_claude_opus: "Claude Opus 4.5 — Massima qualità",
    model_gpt_52: "GPT-5.2 — Ultimo modello",
    model_gpt_4o: "GPT-4o — Multimodale",
    model_gpt_41_mini: "GPT-4.1 Mini — Rapido",
    model_gemini_flash: "Gemini 3 Flash — Rapido",
    model_gemini_pro: "Gemini 3.1 Pro — Contesto lungo",
    mic_start: "Parla con NEURACOM",
    mic_stop: "Stop e trascrivi",
    mic_transcribing: "Trascrizione in corso…",
    mic_denied: "Permesso microfono negato. Abilita l'accesso dal browser per dettare.",
    mic_unsupported: "Il tuo browser non supporta l'input vocale.",
    mic_too_short: "Registrazione troppo breve — tieni premuto più a lungo.",
    mic_no_speech: "Nessuna voce rilevata. Riprova.",
    mic_no_device: "Nessun microfono trovato su questo dispositivo.",
    mic_failed: "Impossibile trascrivere l'audio. Riprova.",
    err_STT_UNSUPPORTED_FORMAT: "Formato audio non supportato.",
    err_STT_FILE_TOO_LARGE: "File audio troppo grande (max 25 MB).",
    err_STT_PROVIDER_ERROR: "Errore del servizio di trascrizione vocale. Riprova più tardi.",
    err_STT_EMPTY_FILE: "Il file audio è vuoto.",
    no_messages: "Inizia una conversazione. Cambia modello quando vuoi.",
    delete_confirm: "Eliminare questa conversazione?",
    smart_chips_title: "Avvio rapido",
    smart_chips_hint: "Scegli un task per indirizzare al cervello AI giusto — o digita liberamente.",
    smart_chip_write_title: "Scrivi",
    smart_chip_write_desc: "Email, post, testi. Routing su GPT.",
    smart_chip_write_prompt: "Aiutami a scrivere un'email chiara e convincente a ",
    smart_chip_code_title: "Codice",
    smart_chip_code_desc: "Debug, refactor, spiegazioni. Routing su Claude.",
    smart_chip_code_prompt: "Aiutami con questo codice — spiegami cosa fa e come migliorarlo:\n\n```\n\n```",
    smart_chip_analyze_title: "Analizza",
    smart_chip_analyze_desc: "Ragionamento, confronti, decisioni. Routing su Claude.",
    smart_chip_analyze_prompt: "Analizza quanto segue e dammi pro, contro e una raccomandazione:\n\n",
    smart_chip_brainstorm_title: "Brainstorm",
    smart_chip_brainstorm_desc: "Idee, nomi, angolazioni. Routing su GPT.",
    smart_chip_brainstorm_prompt: "Fai brainstorm di 10 idee creative su ",
    smart_chip_image_title: "Descrivi un'immagine",
    smart_chip_image_desc: "Comprensione multimodale. Routing su Gemini.",
    smart_chip_image_prompt: "Sto per descrivere un'immagine (o incollare un link). Aiutami a scrivere un alt-text dettagliato e una didascalia marketing: ",
    smart_chip_research_title: "Ricerca",
    smart_chip_research_desc: "Fonti, riassunti, documenti lunghi. Routing su Gemini.",
    smart_chip_research_prompt: "Fai una ricerca e riassumi le ultime informazioni su ",
    brain_hint_code: "Sembra codice — per la programmazione {brain} dà risposte più precise.",
    brain_hint_analyze: "Serve ragionamento attento — {brain} è il migliore nell'analisi passo-passo.",
    brain_hint_research: "Sembra un task di ricerca — {brain} gestisce meglio contesti lunghi e fonti.",
    brain_hint_creative: "È un task di scrittura creativa — {brain} produce testi più naturali.",
    brain_hint_switch: "Passa a {brain}",
    help_which_brain: "Quale cervello?",
    legal_mode_on: "Modalità Legale ON",
    legal_mode_off: "Modalità Legale",
    legal_mode_active: "Modalità Legale attiva — assistente specializzato IT/UE",
    legal_mode_inactive: "Clicca per attivare l'assistente giuridico specializzato (IT/UE)",
    legal_short: "Legale",
    legal_disclaimer: "Modalità Legale attiva: assistente specializzato in diritto italiano ed UE. Le risposte hanno valore informativo e NON sostituiscono un avvocato iscritto all'albo o un DPO certificato.",
    kb_context_title: "Contesto KB attivo · {count}",
    kb_context_clear: "Rimuovi tutte",
    kb_context_hint: "Queste note dalla tua KB personale verranno inviate come contesto fondante per il prossimo messaggio.",
    kb_suggest_title: "Suggerite dalla tua KB",
    kb_suggest_include: "Includi",
    kb_suggest_dismiss: "Ignora",
    kb_suggest_added: "Nota aggiunta al contesto della chat",
    auto_include_on: "Auto-KB",
    auto_include_off: "Auto-KB",
    auto_short: "AI",
    auto_include_active: "Auto-include ON — il server seleziona le top-3 note KB per ogni messaggio",
    auto_include_inactive: "Auto-include OFF — clicca per attivare il contesto KB automatico",
    auto_include_banner: "Auto-KB attivo — le top-3 note dalla tua KB verranno iniettate automaticamente nel prossimo messaggio.",
    legal_templates_title: "Template:",
    legal_templates: {
      consulting_label: "Contratto di consulenza",
      consulting_prompt: "Redigi un contratto di consulenza professionale tra una Srl italiana (committente) e un consulente freelance (consulente) per attività di consulenza IT. Include: parti, oggetto, durata 12 mesi con rinnovo tacito, compenso (€X/ora + tetto mensile), clausola di riservatezza, cessione IP dei deliverable, clausola GDPR responsabile esterno (art. 28), recesso per giusta causa, foro competente Italia.",
      nda_label: "NDA / Riservatezza",
      nda_prompt: "Redigi un NDA reciproco (bilaterale) di diritto italiano tra due Srl per fase di trattativa. Include: definizione 'Informazioni Riservate', esclusioni, durata 5 anni, obbligo di restituzione/distruzione, penale €50.000 per ogni violazione, foro esclusivo Milano, oltre a riferimento art. 28 GDPR se dovessero scambiarsi dati personali.",
      privacy_gdpr_label: "Informativa privacy GDPR (art. 13)",
      privacy_gdpr_prompt: "Redigi un'informativa privacy ex art. 13 GDPR per un sito e-commerce B2C. Copri: identità del titolare, contatti del DPO (se nominato), categorie di dati, basi giuridiche (art. 6 GDPR), destinatari, tempi di conservazione, trasferimenti extra-UE (art. 44 ss.), diritti dell'interessato (art. 15-22), diritto di reclamo al Garante Privacy, profilazione/decisioni automatizzate ex art. 22.",
      ecommerce_tc_label: "T&C e-commerce (B2C)",
      ecommerce_tc_prompt: "Redigi i Termini & Condizioni B2C per un sito e-commerce italiano di elettronica di consumo. Include: parti, conclusione del contratto, prezzo/IVA, pagamento, spedizione/consegna, diritto di recesso legale (art. 52 Codice del Consumo, 14 giorni), garanzia legale (art. 130-135 Codice del Consumo, 24 mesi), limiti di responsabilità, link piattaforma ODR/risoluzione online controversie, foro del consumatore ex art. 33 D.Lgs. 206/2005.",
      diffida_label: "Lettera di diffida",
      diffida_prompt: "Redigi una lettera di diffida ad adempiere ex art. 1454 c.c. nei confronti di una Srl italiana inadempiente al pagamento di una fattura di €X entro la scadenza. Concedi 15 giorni per adempiere, richiama il riferimento contrattuale, calcola gli interessi legali di mora ex D.Lgs. 231/2002 per ritardi B2B, e avverti che alla scadenza il contratto si intenderà risolto di diritto ipso iure e si procederà in via giudiziale.",
      disdetta_locazione_label: "Disdetta locazione",
      disdetta_locazione_prompt: "Redigi una disdetta del contratto di locazione 4+4 ad uso abitativo ex L. 431/1998 da parte del conduttore, con preavviso 6 mesi come da norma. Indica indirizzo immobile, estremi registrazione contratto, data di cessazione richiesta, eventuali 'gravi motivi' ex art. 3 L. 431/1998 se applicabili, e richiesta di incontro per lettura contatori finale.",
      disciplinare_label: "Contestazione disciplinare (art. 7 St. Lav.)",
      disciplinare_prompt: "Redigi una lettera di contestazione disciplinare a un dipendente ex art. 7 L. 300/1970 (Statuto dei Lavoratori) e del CCNL applicabile. Specifica i fatti in dettaglio (data, ora, luogo, testimoni), le clausole contrattuali violate, concedi i 5 giorni per giustificazioni scritte, e ricorda il diritto del lavoratore a essere sentito con assistenza sindacale.",
    },
    err_QUOTA_MESSAGES_EXCEEDED: "Limite mensile messaggi raggiunto. Aggiorna il piano per continuare.",
    err_LLM_PROVIDER_ERROR: "Errore del provider AI. Prova un altro modello.",
  },
  brains: {
    back: "← Torna alla chat",
    pretitle: "Modelli AI · Come scegliere",
    title: "Tre cervelli. Un solo abbonamento.",
    subtitle: "Ogni modello ha una sua personalità. Scegli quello adatto al tuo task — oppure lascia che NEURACOM te lo consigli automaticamente.",
    strengths: "Punti di forza",
    try_example: "Prova questo esempio",
    pick_btn: "Usa questo cervello ora",
    col_dimension: "Dimensione",
    row_best_for: "Ideale per",
    row_speed: "Velocità",
    row_context: "Finestra di contesto",
    row_languages: "Lingue",
    row_style: "Stile",
    claude: {
      tagline: "Il ragionatore preciso",
      strength_1: "Scrivere e spiegare codice con precisione chirurgica",
      strength_2: "Ragionamento lungo, contratti, analisi legale",
      strength_3: "Sa rifiutare educatamente quando qualcosa non torna — meno allucinazioni",
      strength_4: "Spiegazioni passo-passo che reggono al controllo",
      example: "Rivedi questa funzione Python per individuare bug e dimmi come la rifattorizzeresti per chiarezza.",
      best_for: "Codice, contratti, ragionamento",
      speed: "Media",
      context: "200K token",
      languages: "Eccellente IT/EN/PL",
      style: "Riflessivo, strutturato",
    },
    gpt: {
      tagline: "Lo scrittore naturale",
      strength_1: "Copy marketing, email e post che suonano umani",
      strength_2: "Brainstorm di tante alternative in modo rapido",
      strength_3: "Assistente general-purpose — conoscenze ampie",
      strength_4: "Tono conversazionale amichevole già di default",
      example: "Scrivi 5 varianti diverse di oggetto per un'email di lancio della nostra nuova piattaforma AI.",
      best_for: "Scrittura, brainstorming, general",
      speed: "Veloce",
      context: "128K token",
      languages: "Eccellente IT/EN/PL",
      style: "Naturale, amichevole",
    },
    gemini: {
      tagline: "Il ricercatore multimodale",
      strength_1: "Comprende immagini e contenuti visivi",
      strength_2: "Elabora documenti enormi trovando l'ago nel pagliaio",
      strength_3: "Conoscenze aggiornate sul mondo e sintesi ricerche",
      strength_4: "Forte con dati strutturati, tabelle, fogli di calcolo",
      example: "Riassumi i risultati chiave di questo PDF di 80 pagine e cita il paragrafo più importante.",
      best_for: "Multimodale, ricerca lunga",
      speed: "Veloce",
      context: "2M token",
      languages: "Eccellente IT/EN/PL",
      style: "Fattuale, completo",
    },
    reassure_switch_title: "Cambia quando vuoi",
    reassure_switch_desc: "Cambia cervello in corso di conversazione. Manteniamo il contesto.",
    reassure_auto_title: "Auto-routing intelligente",
    reassure_auto_desc: "Scrivi liberamente — ti suggeriamo se un cervello diverso sarebbe più adatto.",
    reassure_lang_title: "Tutti e tre fluenti",
    reassure_lang_desc: "Italiano, inglese e polacco — stessa qualità su tutti i modelli.",
  },
  team: {
    nav_label: "Team",
    title: "Team",
    pretitle: "Magic Inbox",
    members_count: "membri",
    upsell_pretitle: "Workspace di team · Piano Business",
    upsell_title: "Porta il tuo team su NEURACOM.",
    upsell_subtitle: "La Magic Inbox è inclusa nel piano Business.",
    upsell_card_title: "Magic Inbox — workspace condiviso del team",
    upsell_card_desc: "Invita fino a 5 colleghi, vedi su cosa stanno lavorando e trasforma NEURACOM nel layer AI della tua azienda.",
    upsell_feat_1: "Fino a 5 posti — invito via email",
    upsell_feat_2: "Feed attività condiviso di tutto il team",
    upsell_feat_3: "Un singolo abbonamento Business copre tutti",
    upsell_cta: "Passa a Business",
    create_title: "Crea il tuo team",
    create_subtitle: "Sei su Business — configura il tuo team in 10 secondi.",
    field_name: "Nome del team",
    field_name_placeholder: "Acme Marketing",
    create_btn: "Crea team",
    created: "Team creato.",
    create_failed: "Impossibile creare il team. Riprova.",
    members_title: "Membri e inviti",
    invite_placeholder: "collega@azienda.com",
    invite_btn: "Invita",
    invited: "Invito inviato.",
    invite_failed: "Impossibile inviare l'invito.",
    invite_pending: "Invito in attesa",
    invite_revoked: "Invito revocato.",
    role_owner: "Owner",
    role_member: "Membro",
    remove_confirm: "Rimuovere questo membro dal team?",
    removed: "Membro rimosso.",
    leave_btn: "Esci dal team",
    leave_confirm: "Sei sicuro di voler uscire dal team?",
    left: "Hai lasciato il team.",
    delete_btn: "Elimina team",
    delete_confirm: "Eliminare definitivamente questo team? Tutti i membri perderanno l'accesso.",
    deleted: "Team eliminato.",
    danger_title: "Zona pericolosa",
    danger_desc: "Eliminare il team rimuove l'assegnazione dei membri. Non elimina i loro account né i loro contenuti.",
    full: "Team al completo. Rimuovi qualcuno prima di invitare di nuovo.",
    feed_title: "Attività del team",
    feed_desc: "Feed live degli eventi importanti di tutti i membri.",
    feed_empty: "Ancora nessuna attività del team. Apparirà qui non appena i membri inizieranno a usare NEURACOM.",
    accept_loading: "Unione al team in corso…",
    accept_success_title: "Sei dentro!",
    accept_success_desc: "Benvenuto nel team {name}.",
    accept_continue: "Apri il workspace del team",
    accept_error_title: "Impossibile accettare l'invito",
    accept_error_generic: "Questo invito non è valido o è scaduto.",
    accept_go_dashboard: "Vai alla dashboard",
    err_TEAM_INVITE_INVALID: "Questo link di invito non è valido o è stato revocato.",
    err_TEAM_INVITE_EXPIRED: "Questo invito è scaduto. Chiedi all'owner di mandarne uno nuovo.",
    err_TEAM_INVITE_EMAIL_MISMATCH: "Questo invito è per un altro indirizzo email.",
    err_TEAM_ALREADY_MEMBER: "Sei già in un team.",
    err_TEAM_LIMIT_REACHED: "Il team ha raggiunto il limite massimo di membri.",
    err_TEAM_REQUIRES_BUSINESS: "Passa al piano Business per creare un team.",
    err_TEAM_INVITE_SELF: "Non puoi invitare te stesso.",
    err_TEAM_INVITE_DUPLICATE: "Esiste già un invito in attesa per questa email.",
    err_TEAM_INVITE_ALREADY_IN_TEAM: "Quell'utente è già in un team.",
    err_TEAM_NOT_OWNER: "Solo l'owner del team può farlo.",
    err_TEAM_OWNER_CANNOT_LEAVE: "Gli owner non possono uscire — elimina il team invece.",
  },
  images: {
    title: "Image Studio",
    prompt_label: "Descrivi l'immagine che vuoi creare",
    prompt_label_edit: "Descrivi come trasformare l'immagine di riferimento",
    prompt_placeholder: "Una skyline futuristica al tramonto, illuminazione cinematografica...",
    prompt_placeholder_edit: "Trasformala in un acquerello / mettila su Marte / aggiungi luci al neon…",
    provider_label: "Provider",
    provider_gemini: "Gemini Nano Banana",
    provider_openai: "OpenAI GPT-Image-1",
    generate_btn: "Genera immagine",
    edit_btn: "Modifica con riferimento",
    edit_badge: "Modifica",
    edit_success: "Immagine modificata",
    gen_success: "Immagine generata",
    generating: "Generazione… può richiedere fino a 60 secondi.",
    gallery: "La tua gallery",
    no_images: "Nessuna immagine ancora. Genera la prima sopra.",
    download: "Scarica",
    reference_label: "Immagine di riferimento (opzionale, per image-to-image)",
    reference_pick: "Clicca per caricare PNG / JPG / WEBP",
    reference_size_hint: "Max 8 MB",
    reference_active: "Riferimento attivo",
    reference_hint: "La prossima generazione trasformerà questa immagine in base al tuo prompt.",
    reference_forced_gemini: "Le immagini di riferimento sono supportate solo da Gemini Nano Banana. Provider cambiato.",
    no_reference_support: "Niente riferimento",
    err_QUOTA_IMAGES_EXCEEDED: "Limite mensile immagini raggiunto. Aggiorna il piano per continuare.",
    err_IMAGE_PROVIDER_ERROR: "Errore del provider immagini. Prova l'altro.",
    err_IMAGE_REFERENCE_INVALID_BASE64: "Impossibile leggere l'immagine di riferimento. Prova un altro file.",
    err_IMAGE_REFERENCE_TOO_LARGE: "Immagine di riferimento troppo grande (max 8 MB).",
    err_REFERENCE_INVALID_TYPE: "Tipo file non supportato — usa PNG, JPG o WEBP.",
  },
  code: {
    title: "AI Code Builder",
    subtitle: "Descrivi una web app o pagina. Ottieni un file HTML completo e funzionante.",
    subtitle_multi: "Descrivi una web app. Ottieni un progetto multi-file completo — preview, modifica, scarica come ZIP.",
    prompt_label: "Cosa costruiamo?",
    prompt_placeholder: "Una landing page per un bar caffetteria con menù, gallery e form contatti…",
    generate_btn: "Genera progetto",
    generating: "Costruzione… può richiedere 30-90 secondi.",
    preview: "Anteprima",
    code: "Codice",
    download_html: "Scarica .html",
    download_file: "Scarica file",
    download_zip: "Scarica ZIP",
    copy_code: "Copia codice",
    copy_file: "Copia file",
    copied: "Copiato!",
    files_label: "{count} file",
    no_files: "Nessun file in questo progetto.",
    projects: "I tuoi progetti",
    no_projects: "Nessun progetto ancora. Descrivi la tua prima idea sopra.",
    generated_success: "Progetto generato",
    err_QUOTA_CODE_EXCEEDED: "Limite mensile generazioni code raggiunto. Aggiorna il piano per continuare.",
    err_CODE_GEN_EMPTY: "Il modello non ha restituito codice valido. Prova a riformulare.",
  },
  billing: {
    title: "Fatturazione e abbonamento",
    current_plan: "Piano attivo",
    renewal: "Rinnovo il",
    no_renewal: "Nessun abbonamento attivo",
    change_plan: "Cambia piano",
    history: "Storico pagamenti",
    no_history: "Nessuna transazione ancora.",
    paid: "Pagato",
    pending: "In attesa",
    failed: "Fallito",
  },
  payment: {
    processing: "Elaborazione del pagamento…",
    success_title: "Pagamento riuscito!",
    success_subtitle: "Il tuo abbonamento è ora attivo.",
    go_dashboard: "Vai alla dashboard",
    cancelled_title: "Pagamento annullato",
    cancelled_subtitle: "Nessun addebito effettuato.",
    back_pricing: "Torna ai prezzi",
  },
  footer: {
    tagline: "Piattaforma AI powered by TelcaVoIP",
    product: "Prodotto",
    legal: "Legale",
    terms: "Termini",
    privacy: "Privacy",
    cookies: "Cookie",
    privacy_center: "Privacy Center",
    contact_us: "Contatti",
    contact: "Contatti",
    copyright: "© 2026 TelcaVoIP International EU — Tutti i diritti riservati",
  },
  documents: {
    title: "Documenti",
    subtitle: "Carica un PDF e chatta con esso. Fai domande, ottieni riassunti — powered by Claude.",
    upload_btn: "Carica PDF",
    upload_hint: "Trascina un PDF qui o clicca per sfogliare (max 10 MB)",
    uploading: "Caricamento ed estrazione testo…",
    list_title: "I tuoi documenti",
    no_documents: "Nessun documento ancora. Carica il tuo primo PDF sopra.",
    pages: "pagine",
    chars: "caratteri",
    ask_placeholder: "Chiedi qualsiasi cosa su questo documento…",
    thinking: "Sto leggendo il documento…",
    open: "Apri",
    err_DOC_INVALID_FORMAT: "Solo file PDF sono supportati.",
    err_DOC_TOO_LARGE: "File troppo grande (max 10 MB).",
    err_DOC_PARSE_ERROR: "Impossibile leggere questo PDF.",
    err_DOC_NO_TEXT_EXTRACTED: "Questo PDF non contiene testo selezionabile (immagine scansionata?).",
    err_QUOTA_DOCUMENTS_EXCEEDED: "Limite mensile documenti raggiunto. Aggiorna il piano.",
    err_QUOTA_MESSAGES_EXCEEDED: "Limite mensile messaggi raggiunto. Aggiorna il piano.",
    truncated_warning: "⚠️ Questo documento è grande ({chars} caratteri). Solo i primi 50.000 caratteri vengono usati per rispondere. Considera di dividere il PDF in file più piccoli per copertura completa.",
    legal_mode_on: "Modalità Legale ON",
    legal_mode_off: "Analisi legale",
    legal_mode_on_hint: "Analisi clausola-per-clausola attiva",
    legal_mode_off_hint: "Clicca per analisi clausola-per-clausola (diritto IT/UE)",
    legal_mode_banner: "Modalità Legale attiva: questo documento verrà analizzato clausola-per-clausola citando articoli specifici del Codice Civile, Codice del Consumo e GDPR, segnalando le clausole vessatorie (ex art. 1341/1342 c.c., art. 33 Codice del Consumo).",
    upload_success: "Documento caricato",
    legal_detected_title: "📜 Documento giuridico rilevato",
    legal_detected_desc: "Abbiamo individuato terminologia legale (articoli, clausole, GDPR, foro). Attiva la Modalità Legale per analisi specializzata clausola-per-clausola con riferimenti normativi al diritto italiano ed UE.",
    legal_detected_cta: "Attiva Modalità Legale",
  },
  referrals: {
    title: "Invita colleghi, guadagna cash",
    subtitle: "Condividi il tuo link. Quando un collega si abbona a Legal Pro o Business, ricevi €20 + 1 mese gratis di Pro + il 5% di commissione su ogni template del marketplace che vende nei 12 mesi successivi.",
    your_code: "Il tuo codice",
    your_link: "Il tuo link referral",
    copy: "Copia",
    copied: "Copiato!",
    stats_invited: "Invitati",
    stats_paying: "Premiati",
    stats_bonus: "Mesi bonus guadagnati",
    stats_credit_balance: "Credito disponibile",
    stats_credit_lifetime: "Guadagnato totale",
    program_title: "Come funziona NEURACOM Affiliate",
    program_step1: "Condividi il tuo link unico con i colleghi",
    program_step2: "Si abbonano a Legal Pro o Business",
    program_step3: "Guadagni €{credit} + 1 mese gratis di Pro",
    program_step4: "Più il 5% sulle loro vendite marketplace per 12 mesi",
    payout_hint: "Il credito confluisce nel payout marketplace (soglia €50). Vai a {sales} per incassare.",
    payout_hint_link: "Le mie vendite",
    commissions_title: "Commissioni recenti dai colleghi invitati",
    commissions_empty: "Nessuna commissione ancora. Quando un collega invitato venderà un template marketplace, il tuo 5% atterrerà qui.",
    commissions_col_buyer: "Acquirente",
    commissions_col_price: "Prezzo vendita",
    commissions_col_commission: "Tuo 5%",
    commissions_col_date: "Data",
    table_title: "Persone che hai invitato",
    no_invites: "Nessun invito ancora. Condividi il tuo link per iniziare.",
    col_user: "Utente",
    col_tier: "Piano",
    col_status: "Stato",
    col_date: "Iscritto il",
    col_eligible: "Finestra commissioni",
    status_rewarded: "Premiato",
    status_pending: "In attesa sub pagato",
    until: "fino al {date}",
    err_REF_INVALID_CODE: "Codice referral non valido.",
    err_REF_SELF_REFERRAL: "Non puoi referenziare te stesso.",
    err_REF_ALREADY_REFERRED: "Hai già un referente.",
    err_REF_NOT_ELIGIBLE_PAID_USER: "Solo utenti Free possono applicare un codice referral.",
  },
  billing_v2: {
    cancel_subscription: "Cancella abbonamento",
    reactivate: "Riattiva abbonamento",
    confirm_cancel: "Sei sicuro? Manterrai l'accesso fino a fine periodo, poi tornerai al piano Free.",
    cancelling_banner: "Il tuo abbonamento terminerà il {date}. Puoi riattivare in qualsiasi momento prima.",
    expiring_soon: "Il tuo abbonamento si rinnova il {date}. Rinnova manualmente prima per mantenere il piano.",
    manual_renewal_note: "ℹ️ Attualmente gli abbonamenti sono mensili, pagati manualmente. Ti notificheremo prima della scadenza.",
  },
  legal: {
    terms_title: "Termini di Servizio",
    terms_intro: "Questi termini regolano l'uso di NEURACOM by TelcaVoIP. Leggi attentamente.",
    terms_last_updated: "Ultimo aggiornamento: Febbraio 2026",
    privacy_title: "Privacy Policy",
    privacy_intro: "Rispettiamo la tua privacy. Questa pagina spiega quali dati raccogliamo e come li usiamo.",
    privacy_last_updated: "Ultimo aggiornamento: Febbraio 2026",
    back_home: "← Torna alla home",
  },
  cookies: {
    banner_aria: "Consenso cookie",
    banner_title: "Rispettiamo la tua privacy.",
    banner_text: "Usiamo solo cookie essenziali per tenerti collegato e ricordare le tue preferenze. Niente tracciamento, niente pubblicità.",
    banner_learn_more: "Scopri di più",
    accept_all: "Ho capito",
    reject_all: "Solo essenziali",
    pill_label: "Cookie",
    pill_aria: "Apri preferenze cookie",
  },
  privacy_center: {
    pretitle: "GDPR · Diritti Privacy",
    title: "Privacy Center",
    subtitle: "Un unico punto per esercitare i tuoi diritti di protezione dei dati — che tu sia un utente attuale, un ex-utente o non abbia mai avuto un account. Rispondiamo entro 30 giorni come previsto dall'art. 12 GDPR.",
    dpo_title: "Responsabile Protezione Dati (DPO)",
    dpo_desc: "Contatto diretto per qualsiasi domanda, richiesta o segnalazione sulla privacy.",
    controller_title: "Titolare del trattamento",
    controller_desc: "L'entità legale responsabile del trattamento dei tuoi dati personali.",
    docs_title: "Documenti legali",
    link_privacy: "Informativa Privacy",
    link_cookies: "Cookie Policy",
    link_terms: "Termini di Servizio",
    form_title: "Invia una richiesta sui dati",
    form_desc: "Usa questo modulo se non hai (o non hai più) un account. Gli utenti registrati possono esercitare questi diritti direttamente dalle Impostazioni.",
    field_email: "La tua email",
    field_type: "Tipo di richiesta",
    field_message: "Messaggio",
    field_message_placeholder: "Descrivi la tua richiesta. Includi qualsiasi contesto che ci aiuti a identificare i tuoi dati (es. ex email, data approssimativa di registrazione).",
    type_access: "Accesso ai miei dati (art. 15)",
    type_portability: "Portabilità dei dati (art. 20)",
    type_rectification: "Rettifica (art. 16)",
    type_erasure: "Cancellazione / oblio (art. 17)",
    type_objection: "Opposizione al trattamento (art. 21)",
    type_other: "Altro / richiesta generica",
    deadline_note: "Rispondiamo entro 30 giorni (art. 12 GDPR).",
    submit_btn: "Invia richiesta",
    submit_success: "Richiesta ricevuta.",
    submit_failed: "Impossibile inviare. Riprova o scrivi direttamente a privacy@telcavoip.eu.",
    success_title: "Richiesta ricevuta",
    success_desc: "Grazie. Abbiamo notificato il nostro DPO e riceverai una risposta entro 30 giorni. Per questioni urgenti scrivi a privacy@telcavoip.eu.",
    authorities_title: "Autorità di controllo",
    authorities_desc: "Se ritieni che i tuoi diritti siano stati violati, puoi presentare reclamo all'autorità di protezione dei dati del tuo paese di residenza o lavoro.",
  },
  settings: {
    title: "Impostazioni",
    pretitle: "Account",
    subtitle: "Gestisci il profilo, la privacy e i tuoi diritti GDPR.",
    profile_title: "Profilo",
    profile_desc: "I dettagli del tuo account.",
    email: "Email",
    name: "Nome",
    plan: "Piano",
    locale: "Lingua",
    cookies_title: "Preferenze cookie",
    cookies_desc: "Rivedi o resetta il consenso che hai dato per i cookie non essenziali.",
    cookies_reset_btn: "Reset consenso cookie",
    cookies_reset_success: "Consenso cookie azzerato. Il banner riapparirà.",
    export_title: "Scarica i tuoi dati",
    export_desc: "Art. 20 GDPR — ottieni un export JSON completo di tutti i dati personali che abbiamo su di te.",
    export_btn: "Esporta i miei dati (JSON)",
    export_success: "Export scaricato.",
    export_failed: "Impossibile generare l'export. Riprova.",
    rights_title: "I tuoi diritti GDPR",
    rights_desc: "In base al regolamento UE 2016/679 hai i seguenti diritti, esercitabili in qualsiasi momento:",
    right_access: "Diritto di accesso (art. 15)",
    right_portability: "Diritto alla portabilità (art. 20)",
    right_erasure: "Diritto alla cancellazione / oblio (art. 17)",
    right_rectification: "Diritto di rettifica (art. 16)",
    right_object: "Diritto di opposizione e limitazione (art. 21-22)",
    edit_profile_btn: "Modifica profilo",
    edit_title: "Modifica profilo",
    edit_desc: "Aggiorna il nome o cambia la password. L'email è bloccata — contatta il supporto per modificarla.",
    change_password: "Cambia password",
    change_password_hint: "Lascia vuoto se non vuoi cambiare la password.",
    current_password: "Password attuale",
    new_password: "Nuova password (min 8 caratteri)",
    edit_save_btn: "Salva modifiche",
    edit_success: "Profilo aggiornato.",
    edit_failed: "Impossibile aggiornare il profilo. Riprova.",
    edit_invalid_password: "La password attuale non è corretta.",
    edit_password_too_short: "La nuova password deve avere almeno 8 caratteri.",
    edit_current_password_required: "Inserisci la password attuale per impostarne una nuova.",
    edit_nothing_to_update: "Modifica qualcosa prima di salvare.",
    danger_title: "Elimina account",
    danger_desc: "Cancella in modo irreversibile il tuo account, chat, immagini, progetti code, documenti, commissioni partner ed eventi attività. I record di pagamento sono pseudonimizzati ma conservati per obblighi contabili.",
    delete_btn: "Elimina il mio account",
    delete_confirm_title: "Conferma eliminazione account",
    delete_confirm_desc: "Per confermare, digita la tua email ({email}) qui sotto. Questa azione non può essere annullata.",
    delete_confirm_btn: "Elimina definitivamente",
    delete_email_mismatch: "L'email non corrisponde.",
    delete_success: "Account eliminato. Ci dispiace vederti andare.",
    delete_failed: "Impossibile eliminare l'account. Contatta il supporto.",
  },
  affiliate_page: {
    hero_pretitle: "Programma Partner",
    hero_title: "Rivendi NEURACOM. Guadagna il 20% ricorrente.",
    hero_subtitle: "Aiuta le aziende ad adottare l'AI e guadagna il 20% di commissione su ogni abbonamento che porti — finché rimangono clienti.",
    cta_apply: "Candidati come partner",
    cta_dashboard: "Apri dashboard partner",
    benefit_commission_title: "20% di commissione, ogni mese",
    benefit_commission_desc: "Ottieni il 20% su ogni abbonamento pagato che referenzi (Starter, Pro, Business). Pagato mensilmente, senza limiti.",
    benefit_tools_title: "Toolkit marketing",
    benefit_tools_desc: "Link brandizzato, dashboard con statistiche e template email per chiudere più velocemente.",
    benefit_priority_title: "Supporto prioritario",
    benefit_priority_desc: "Linea diretta col nostro team. Ti aiutiamo a onboardare i primi clienti.",
    how_title: "Come funziona",
    how_step1_title: "1. Candidati",
    how_step1_desc: "Invia la tua candidatura. La esaminiamo entro 48h.",
    how_step2_title: "2. Condividi il link",
    how_step2_desc: "Una volta approvato, condividi il tuo link unico con i lead.",
    how_step3_title: "3. Guadagna",
    how_step3_desc: "20% di commissione su ogni abbonamento pagato. Richiedi il payout quando vuoi.",
    form_title: "Diventa partner NEURACOM",
    form_company: "Nome azienda (opzionale)",
    form_website: "Sito web (opzionale)",
    form_volume: "Referral mensili previsti",
    form_pitch: "Raccontaci del tuo pubblico",
    form_submit: "Invia candidatura",
    status_pending_title: "Candidatura in revisione",
    status_pending_desc: "Grazie! Il nostro team revisionerà entro 48 ore. Riceverai un'email all'approvazione.",
    status_approved_title: "Sei un partner!",
    status_approved_desc: "Apri la tua dashboard per ottenere il link e iniziare a guadagnare.",
    status_rejected_title: "Candidatura non approvata",
    status_rejected_desc: "Purtroppo non possiamo approvare la tua candidatura al momento. Contattaci per dettagli.",
    err_AFFILIATE_ALREADY_APPLIED: "Hai già fatto domanda o sei già un partner.",
    application_submitted: "Candidatura inviata!",
  },
  jurisprudence: {
    hero_pretitle: "Banca Dati Legale NEURACOM",
    title: "Giurisprudenza Italiana ed UE",
    title_nav: "Giurisprudenza",
    subtitle: "Cerca in un corpus curato di {count} massime storiche da Cassazione, Corte Costituzionale, CGUE e Garante Privacy. Citate automaticamente dalla Modalità Legale quando pertinenti.",
    search_placeholder: "es. 'clausole vessatorie', 'consenso GDPR', 'art. 1341 c.c.'…",
    search_btn: "Cerca",
    filter_by_topic: "Filtra per argomento",
    empty_title: "Cerca un principio giuridico, un argomento o un articolo",
    empty_desc: "Oppure clicca un argomento qui sopra per esplorare.",
    no_results: "Nessuna massima corrisponde alla ricerca. Prova una parola chiave diversa o rimuovi il filtro.",
    disclaimer_title: "Nota:",
    disclaimer_body: "Questo è un corpus educativo curato a mano, NON sostituisce banche dati professionali come Italgiure, De Jure o Westlaw. Verifica sempre le citazioni su fonti ufficiali prima di usarle in giudizio.",
    topics: {
      diritto_civile: "Diritto civile",
      contratti: "Contratti",
      nullita: "Nullità",
      consumatori: "Tutela consumatori",
      clausole_vessatorie: "Clausole vessatorie",
      B2C: "B2C",
      UE: "Diritto UE",
      GDPR: "GDPR",
      privacy: "Privacy",
      consenso: "Consenso",
      trasferimenti_extra_UE: "Trasferimenti extra-UE",
      marketing: "Marketing",
      newsletter: "Newsletter",
      lavoro: "Diritto del lavoro",
      licenziamento: "Licenziamento",
      art_18: "Art. 18 St. Lav.",
      disciplinare: "Disciplinare",
      art_7_st_lav: "Art. 7 St. Lav.",
      mobbing: "Mobbing",
      danno: "Danno",
      gig_economy: "Gig economy",
      riders: "Riders",
      locazione: "Locazioni",
      registrazione: "Registrazione",
      disdetta: "Disdetta",
      gravi_motivi: "Gravi motivi",
      e_commerce: "E-commerce",
      informativa: "Informativa",
      garanzia_legale: "Garanzia legale",
      penale: "Diritto penale",
      diffamazione: "Diffamazione",
      internet: "Internet",
      "231_2001": "D.Lgs. 231/2001",
      compliance: "Compliance",
      cyber: "Cyber",
      accesso_abusivo: "Accesso abusivo",
      tributario: "Diritto tributario",
      abuso_diritto: "Abuso del diritto",
      art_10_bis: "Art. 10-bis",
      societario: "Diritto societario",
      azione_responsabilita: "Azione responsabilità",
      amministratori: "Amministratori",
      famiglia: "Diritto di famiglia",
      assegno_divorzile: "Assegno divorzile",
      costituzionale: "Costituzionale",
      fine_vita: "Fine vita",
      suicidio_assistito: "Suicidio assistito",
      doppia_pregiudizialita: "Doppia pregiudizialità",
      proprieta_intellettuale: "Proprietà intellettuale",
      marchi: "Marchi",
      registrazione_malafede: "Registrazione in malafede",
      diritto_autore: "Diritto d'autore",
      sampling: "Sampling",
      procedura_civile: "Procedura civile",
      mediazione: "Mediazione",
      condizione_procedibilita: "Condizione procedibilità",
      bancario: "Diritto bancario",
      usura: "Usura",
      tasso_soglia: "Tasso soglia",
      anatocismo: "Anatocismo",
      interessi: "Interessi",
      AI_act: "AI Act",
      intelligenza_artificiale: "Intelligenza artificiale",
      intermediazione_finanziaria: "Intermediazione finanziaria",
      responsabilita_medica: "Responsabilità medica",
      foro_competente: "Foro competente",
      antitrust: "Antitrust",
      intese_anticoncorrenziali: "Intese anticoncorrenziali",
      successioni: "Successioni",
      legittimari: "Legittimari",
      azione_riduzione: "Azione di riduzione",
      smart_working: "Smart working",
      diritto_disconnessione: "Diritto disconnessione",
      ferie: "Ferie",
      somministrazione: "Somministrazione",
      dimissioni: "Dimissioni",
      maternita: "Maternità",
      fideiussione: "Fideiussione",
      phishing: "Phishing",
      frodi_online: "Frodi online",
      mutuo: "Mutuo",
      estinzione_anticipata: "Estinzione anticipata",
      assicurazioni: "Assicurazioni",
      RC_auto: "RC auto",
      claims_made: "Claims made",
      condominio: "Condominio",
      amministrativo: "Diritto amministrativo",
      appalti: "Appalti pubblici",
      immigrazione: "Immigrazione",
      protezione_internazionale: "Protezione internazionale",
      telecomunicazioni: "Telecomunicazioni",
      videosorveglianza: "Videosorveglianza",
      smart_home: "Smart home",
      social_network: "Social network",
      responsabilita_piattaforme: "Responsabilità piattaforme",
      diritto_oblio: "Diritto all'oblio",
      decisioni_automatizzate: "Decisioni automatizzate",
      scoring: "Credit scoring",
      tech_giants: "Big Tech",
      revenge_porn: "Revenge porn",
      stalking: "Stalking",
      riciclaggio: "Riciclaggio",
      sicurezza_lavoro: "Sicurezza sul lavoro",
      infortunio: "Infortunio sul lavoro",
      covid: "COVID-19",
      crisi_impresa: "Crisi d'impresa",
      greenwashing: "Greenwashing",
      pratiche_scorrette: "Pratiche scorrette",
      ambiente: "Ambiente",
      energia: "Energia",
      fonti_rinnovabili: "Fonti rinnovabili",
      sport: "Diritto sportivo",
      trasporti: "Trasporti",
      turismo: "Turismo",
      usucapione: "Usucapione",
      immissioni: "Immissioni",
      testamento: "Testamento",
      gestazione_terzi: "Gestazione per altri",
      affidamento_condiviso: "Affidamento condiviso",
      alienazione_parentale: "Alienazione parentale",
      convivenza: "Convivenza di fatto",
      riforma_cartabia: "Riforma Cartabia",
      notifica: "Notifica",
      PEC: "PEC",
      accertamento: "Accertamento",
      iva: "IVA",
      false_comunicazioni_sociali: "False comunicazioni sociali",
    },
    save_to_kb: "Salva nella mia KB",
    kb_saved: "Salvata nella tua Knowledge Base",
    kb_save_failed: "Salvataggio non riuscito — riprova",
  },
  legal_kb: {
    title: "Knowledge Base Legale Personale",
    title_nav: "KB Legale",
    pretitle: "Legal Pro · Database privato",
    subtitle: "{count} note private — fissa massime, salva risposte AI, raccogli il tuo know-how legale. Tutto rimane nel tuo account.",
    new_note: "Nuova nota",
    new_title: "Nuova nota",
    edit_title: "Modifica nota",
    search_placeholder: "Cerca in titolo, contenuto, citazione…",
    search_btn: "Cerca",
    filter_by_tag: "Filtra per tag",
    clear_tag: "Rimuovi tag",
    empty_title: "La tua Knowledge Base è vuota",
    empty_desc: "Salva massime di giurisprudenza, copia risposte della chat o scrivi le tue note. Tutto privato e accessibile solo a te.",
    source_all: "Tutte",
    source_jurisprudence: "Massime",
    source_chat: "Chat",
    source_document: "Documenti",
    source_manual: "Manuali",
    pin: "Fissa in cima",
    unpin: "Sblocca",
    edit: "Modifica",
    delete: "Elimina",
    confirm_delete: "Eliminare questa nota? L'azione non è reversibile.",
    toast_created: "Nota salvata nella Knowledge Base",
    toast_updated: "Nota aggiornata",
    toast_deleted: "Nota eliminata",
    err_load: "Impossibile caricare le note",
    err_save: "Salvataggio non riuscito",
    err_delete: "Eliminazione non riuscita",
    err_required: "Titolo e contenuto sono obbligatori",
    err_LEGAL_KB_TIER_REQUIRED: "La Knowledge Base personale è disponibile sui piani Legal Pro e Business.",
    err_LEGAL_KB_NOTE_NOT_FOUND: "Questa nota non esiste più.",
    field_title: "Titolo",
    field_title_ph: "es. Clausole vessatorie nei contratti B2C",
    field_citation: "Citazione (facoltativa)",
    field_citation_ph: "es. Cass. civ. Sez. III n. 8268/2008",
    field_body: "Contenuto",
    field_body_ph: "Scrivi una nota, incolla una risposta AI o descrivi un principio giuridico…",
    field_tags: "Tag",
    field_tags_ph: "contratti, B2C, gdpr",
    field_tags_hint: "Separati da virgola. Massimo 20 tag.",
    save_changes: "Salva modifiche",
    save_note: "Salva nota",
    disclaimer: "Le note salvate sono private del tuo account NEURACOM. NON sostituiscono il parere di un avvocato — verifica le citazioni su fonti ufficiali (Italgiure, De Jure, EUR-Lex).",
    upsell_title: "Disponibile su Legal Pro & Business",
    upsell_body: "Costruisci la tua banca dati legale privata dentro NEURACOM. Salva massime, risposte AI e note personali — tutto ricercabile, tagged e cifrato a riposo.",
    upsell_bullet1: "Salva qualsiasi massima con un clic",
    upsell_bullet2: "Cattura risposte AI come massime riutilizzabili",
    upsell_bullet3: "Tag, ricerca e pin — il tuo corpus cresce con te",
    upsell_cta: "Passa a Legal Pro",
    save_chat_btn: "Salva in KB",
    save_chat_title: "Salva risposta AI",
    save_chat_hint: "Aggiungi un titolo e una citazione, poi salva questa risposta nella tua Knowledge Base privata.",
    use_in_chat: "Usa in chat",
    use_in_chat_added: "Nota aggiunta come contesto per la prossima chat",
    use_in_chat_already: "Questa nota è già nel contesto della chat",
    use_in_chat_max: "Massimo {max} note per chat — rimuovine una prima",
  },
  fable5: {
    banner_title: "Avvisami su Claude Fable 5",
    banner_body: "Sii tra i primi a sapere quando Fable 5 (finestra di contesto 1M) sarà disponibile nativamente su NEURACOM Legal Pro. Ti invieremo una sola email di avviso.",
    join_cta: "Avvisami",
    leave: "Annulla iscrizione",
    subscribed: "Sei nella waitlist",
    toast_joined: "Riceverai una notifica quando Fable 5 sarà disponibile",
    toast_join_failed: "Iscrizione non riuscita — riprova",
    toast_left: "Rimosso dalla waitlist",
    toast_leave_failed: "Annullamento non riuscito — riprova",
  },
  comparison: {
    pretitle: "Confronto · Perché un AI legale verticale conta",
    title: "ChatGPT generico vs. NEURACOM Legal Pro",
    subtitle: "Stesso budget mensile, output radicalmente diverso. Il dettaglio delle citazioni e il framework privacy sono il punto dove avvocati, DPO e commercialisti perdono ore ogni settimana con l'AI generica.",
    col_feature: "Funzionalità",
    col_generic: "AI generica",
    col_neuracom: "NEURACOM Legal Pro",
    generic_subtitle: "ChatGPT Plus / equiv.",
    neuracom_subtitle: "AI legale verticale",
    cat_citations: "Citazioni & ricerca giurisprudenziale",
    cat_privacy: "Privacy & compliance",
    cat_workflow: "Workflow legale",
    cat_cost: "Costo & ROI",
    row_jurisprudence: "Database di 103 massime curate Cassazione + CGUE",
    row_kb: "Knowledge Base Legale personale (privata, cifrata)",
    row_auto_cite: "Auto-cite & suggerimenti ambient KB mentre digiti",
    row_hallucinations: "Citazioni verbatim, resistenti alle allucinazioni",
    row_eu_hosted: "Infrastruttura hosted in UE",
    row_gdpr: "100% GDPR-compliant by design",
    row_no_training: "I tuoi dati non addestrano mai modelli esterni",
    row_templates: "7 template legali italiani pre-compilati (NDA, GDPR, contratti…)",
    row_legal_register: "Registro formale giuridico italiano out-of-the-box",
    row_doc_analysis: "Analisi clausola-per-clausola di contratti PDF",
    row_price: "Abbonamento mensile",
    row_value: "Tempo risparmiato in ricerca legale (~10h/mese)",
    roi_headline: "Payback: ~3 giorni/mese a tariffa €60/h.",
    roi_body: "Un avvocato italiano in proprio a €60/h risparmia circa 10 ore/mese di ricerca giurisprudenziale con NEURACOM Legal Pro. Sono €600 di tempo fatturabile recuperato — per un abbonamento da €149/mese. La matematica è brutale.",
  },
  atti: {
    title_nav: "Atto Generator",
    pretitle: "Legal Pro · Killer feature",
    title: "Genera atti legali completi in 60 secondi",
    subtitle: "Scegli il tipo di atto, compila 3 campi, ricevi un documento giuridico italiano formale completo — registro forense, sezioni numerate, citazioni auto-iniettate dalla tua KB Personale tramite Claude Opus 4.8.",
    sections_count: "sezioni",
    start: "Inizia",
    back: "Indietro",
    form_hint: "Sezioni obbligatorie: {sections}",
    field_parties: "Parti coinvolte",
    field_parties_ph: "es. Mario Rossi (attore) c. ACME S.r.l. (convenuta)",
    field_subject: "Oggetto / Materia",
    field_subject_ph: "es. Risoluzione contrattuale + risarcimento danni",
    field_facts: "Fatti rilevanti",
    field_facts_ph: "Descrivi date, importi, inadempimenti, comunicazioni, danno subito…",
    field_court: "Foro / Autorità (facoltativo)",
    field_court_ph: "es. Tribunale di Milano — Sez. Imprese",
    field_context: "Contesto ulteriore (facoltativo)",
    field_context_ph: "tentativi precedenti, note strategiche…",
    generate_cta: "Genera l'atto",
    kb_hint: "Le 4 note più rilevanti dalla tua KB Personale verranno iniettate automaticamente.",
    generating_title: "Sto redigendo il tuo documento",
    generating_hint: "Claude Opus 4.8 sta scrivendo in registro forense italiano.",
    chars: "caratteri",
    kb_used: "note KB utilizzate",
    copy: "Copia",
    print: "Stampa",
    save_to_kb: "Salva in KB",
    new_atto: "Nuovo atto",
    toast_generated: "Documento pronto — rivedi e modifica prima del deposito",
    toast_copied: "Copiato negli appunti",
    toast_saved_kb: "Salvato nella tua Knowledge Base",
    err_required: "Parti, oggetto e fatti sono obbligatori",
    err_generation: "Generazione fallita — riprova",
    err_copy: "Copia fallita",
    err_save_kb: "Impossibile salvare in KB",
    tab_create: "Nuovo atto",
    tab_archive: "I miei atti",
    archive_search_ph: "Cerca per oggetto o parti…",
    archive_filter_all: "Tutti i tipi",
    archive_empty_title: "Nessun atto ancora",
    archive_empty_body: "Ogni atto che generi viene salvato qui automaticamente. Inizia con uno nuovo — ti richiede 60 secondi.",
    archive_empty_cta: "Genera il tuo primo atto",
    archive_view: "Apri",
    archive_delete: "Elimina",
    archive_delete_confirm: "Eliminare questo atto? L'operazione è irreversibile.",
    archive_delete_success: "Atto rimosso dall'archivio",
    archive_open_back: "Torna ai miei atti",
    archive_count_one: "{count} atto",
    archive_count_many: "{count} atti",
    archive_loading: "Carico i tuoi atti…",
    archive_load_error: "Impossibile caricare i tuoi atti",
    archive_filter_label: "Filtra per tipo",
    upsell_title: "Atto Generator è parte di Legal Pro",
    upsell_body: "Genera atti legali completi (memorie, ricorsi, pareri, diffide…) in registro forense italiano formale, con citazioni Auto-KB iniettate da Claude Opus 4.8. Disponibile sui piani Legal Pro e Business.",
    upsell_cta: "Passa a Legal Pro",
  },
  partner: {
    title: "Dashboard Partner",
    subtitle: "Monitora le tue commissioni e fai crescere il tuo business.",
    your_link: "Il tuo link partner",
    copy: "Copia",
    stat_pending: "In sospeso",
    stat_ready: "Pronte per payout",
    stat_paid: "Pagate",
    stat_lifetime: "Totali",
    stat_count: "Commissioni",
    commissions_title: "Commissioni recenti",
    no_commissions: "Nessuna commissione. Condividi il tuo link per iniziare.",
    col_user: "Utente referenziato",
    col_plan: "Piano",
    col_amount: "Importo",
    col_commission: "Commissione",
    col_status: "Stato",
    col_date: "Data",
    status_pending: "In attesa",
    status_ready_for_payout: "Pronta",
    status_paid: "Pagata",
    request_payout: "Richiedi payout",
    payout_requested: "Payout richiesto",
    link_copied: "Link copiato",
    open_kit: "Kit di lancio",
    share: "Condividi",
  },
  partner_landing: {
    recommended_by: "Raccomandato da",
    hero_pretitle: "Offerta esclusiva · Piattaforma AI",
    hero_title: "Porta l'AI nella tua azienda — in ogni lingua.",
    hero_subtitle_prefix: "Selezionato da",
    hero_subtitle_suffix: ", NEURACOM ti dà Claude, GPT e Gemini, generazione immagini AI, Q&A sui documenti e un code builder — tutto in un unico abbonamento UE.",
    cta_primary: "Inizia gratis — senza carta",
    cta_secondary: "Vedi prezzi",
    trust_gdpr: "GDPR-friendly",
    trust_eu: "Infrastruttura UE",
    trust_nocard: "Senza carta di credito",
    feat_chat: "Chat AI Multi-modello",
    feat_image: "Generazione Immagini",
    feat_code: "AI Code Builder",
    feat_docs: "Q&A sui Documenti",
    results_title: "Risultati di team reali",
    result1_label: "Tempo di stesura",
    result1_quote: "Abbiamo tagliato del 75% il tempo di produzione contenuti nel team marketing.",
    result2_label: "Tasso risposta vendite",
    result2_quote: "Le email outbound personalizzate hanno triplicato il nostro tasso di risposta nel primo mese.",
    result3_label: "Dall'idea alla landing page",
    result3_quote: "Ho descritto la nuova offerta in italiano e ho pubblicato la landing prima di pranzo.",
    cta_title: "Inizia gratis oggi.",
    cta_subtitle: "Aggiorna solo quando lanci qualcosa di vero.",
    cta_button: "Crea il tuo account",
    cta_attribution: "Portato a te da",
    not_found_title: "Link partner non trovato",
    not_found_desc: "Questo link di invito non è valido o è scaduto. Verifica l'URL con il tuo partner.",
    go_home: "Vai alla home",
  },
  partner_kit: {
    back: "Torna alla dashboard",
    title: "Kit di Lancio",
    subtitle: "Tutto quello che ti serve per acquisire i primi clienti. Copia, personalizza, invia.",
    cobranded_label: "La tua landing co-branded",
    cobranded_desc: "Invia questo link ai lead. Atterrano su una pagina con \"Raccomandato da te\" e ogni registrazione è tracciata sul tuo account.",
    preview: "Anteprima",
    tab_email: "Email",
    tab_social: "Social",
    tab_chat: "Chat / DM",
    subject_label: "Oggetto",
    copy: "Copia",
    copied: "Copiato!",
    no_templates: "Nessun template disponibile.",
    email_cold_title: "Primo contatto a freddo",
    email_cold_subject: "Uno spazio AI che il tuo team userà davvero",
    email_cold_body: "Ciao {nome},\n\nDomanda veloce: stai ancora saltando tra schede ChatGPT, un tool separato per le immagini e Google Docs per lavorare con l'AI?\n\nHo iniziato a consigliare NEURACOM — un unico workspace UE con Claude, GPT e Gemini, generazione immagini, Q&A documenti e un AI code builder. Italiano, inglese e polacco subito disponibili, zero setup.\n\nI miei clienti risparmiano in media ore già nella prima settimana. Puoi iniziare gratis, senza carta:\n\n{{LINK}}\n\nSe ti serve una call di 15 minuti per vederlo insieme, scrivimi.\n\nA presto,\n{{PARTNER}}",
    email_followup_title: "Follow-up (nessuna risposta)",
    email_followup_subject: "Ti è arrivato il link di NEURACOM?",
    email_followup_body: "Ciao {nome},\n\nRimetto su l'email sopra nel caso si fosse persa. NEURACOM è il workspace AI europeo di cui ti parlavo — chat multi-modello, generazione immagini, Q&A documenti e code builder, tutto in un posto.\n\nSe ti bastano 5 minuti per vedere se può davvero sostituire 4 tool, qui hai un account gratuito:\n\n{{LINK}}\n\nNessuna carta. Disdici quando vuoi.\n\n{{PARTNER}}",
    email_value_title: "Pitch di valore (lead caldo)",
    email_value_subject: "3 cose che NEURACOM fa e ChatGPT da solo no",
    email_value_body: "Ciao {nome},\n\nCome promesso, tre cose che NEURACOM fa e che ripagano l'abbonamento nella prima settimana:\n\n1. Fai domande in linguaggio naturale a qualsiasi PDF — contratti, manuali, fatture. Risposte citate, senza fronzoli.\n2. Genera l'immagine giusta per ogni post blog/social con Gemini Nano Banana o GPT-Image-1, dentro la stessa app.\n3. Descrivi un'app o una landing page nella tua lingua → ottieni l'HTML funzionante con un click.\n\nTutto con un unico abbonamento UE, GDPR-friendly, interfaccia trilingua (IT/EN/PL).\n\nInizia gratis qui:\n\n{{LINK}}\n\nFammi sapere se vuoi un walkthrough 1-a-1.\n\n{{PARTNER}}",
    social_linkedin_title: "Post LinkedIn",
    social_linkedin_body: "La maggior parte dei team che incontro usa 3-4 tool AI diversi — e continua a fare copia-incolla tra l'uno e l'altro.\n\nUltimamente sto consigliando NEURACOM ai miei clienti perché risolve davvero il problema:\n\n→ Un solo workspace, tre modelli AI (Claude / GPT / Gemini)\n→ Generazione immagini, Q&A documenti e AI code builder integrati\n→ Infrastruttura UE, GDPR-friendly, trilingua (IT/EN/PL)\n→ Prezzi mensili trasparenti, nessuna sorpresa sui token\n\nGratis per provare, senza carta:\n{{LINK}}\n\n#AI #produttività #UE",
    social_twitter_title: "Post Twitter / X",
    social_twitter_body: "Stop a 4 tool AI diversi.\n\nNEURACOM = Claude + GPT + Gemini + image gen + Q&A doc + code builder in un unico workspace UE.\n\nUI trilingua. GDPR-friendly. Gratis per iniziare.\n\n{{LINK}}",
    social_facebook_title: "Post Facebook",
    social_facebook_body: "Se tu (o il tuo team) state pagando ChatGPT, Midjourney e altri abbonamenti AI, dai un'occhiata a NEURACOM. Un unico workspace europeo con Claude, GPT, Gemini, generazione immagini, Q&A documenti e AI code builder — italiano, inglese, polacco da subito.\n\nGratis per provare, senza carta:\n{{LINK}}",
    chat_whatsapp_title: "WhatsApp / Telegram",
    chat_whatsapp_body: "Ciao 👋 ti scrivo veloce — uso NEURACOM da un po' ed è praticamente Claude + GPT + Gemini + image gen + Q&A documenti in un'unica app europea. Piano gratuito, senza carta. Penso possa aiutare il tuo team:\n{{LINK}}",
    chat_dm_title: "DM LinkedIn / Slack",
    chat_dm_body: "Ciao {nome}, penso che NEURACOM possa farti risparmiare un sacco di context-switching al team. Un solo workspace UE per Claude / GPT / Gemini + image gen + Q&A documenti. Gratis per provare (senza carta):\n{{LINK}}\nSe ti serve, ti faccio vedere come funziona.",
  },
  activity: {
    pretitle: "Attività",
    title: "La tua timeline",
    subtitle: "Tutto quello che succede al tuo account in un unico posto. Ti mandiamo le stesse notifiche via email — qui è solo più rapido.",
    mark_all_read: "Segna tutto come letto",
    empty_title: "Ancora nessun evento",
    empty_desc: "Le attività appariranno qui man mano che usi NEURACOM.",
    load_more: "Carica altri",
    action_dashboard: "Apri dashboard",
    action_kit: "Apri Kit di lancio",
    action_partner: "Dashboard partner",
    action_upgrade: "Vedi i piani",
    event: {
      welcome: {
        title: "Benvenuto in NEURACOM",
        desc: "Il tuo account è pronto all'uso.",
      },
      subscription_activated: {
        title: "Abbonamento attivato",
        desc: "Piano {plan} · {amount} — 30 giorni di accesso completo.",
      },
      partner_approved: {
        title: "Candidatura partner approvata",
        desc: "Sei un partner approvato. È il momento di condividere il tuo kit.",
      },
      commission_earned: {
        title: "Nuova commissione",
        desc: "+{amount} da un abbonamento {plan} referenziato.",
      },
      payout_requested: {
        title: "Payout richiesto",
        desc: "{amount} richiesti — {count} commissioni in coda.",
      },
      payout_paid: {
        title: "Payout inviato",
        desc: "{amount} accreditati sul tuo conto.",
      },
      quota_warning: {
        title: "Quota in esaurimento",
        desc: "Usato il {pct}% del limite {resource} di questo mese.",
      },
    },
  },
  admin: {
    title: "Admin Console",
    subtitle: "Gestisci codici promo, partner e commissioni.",
    tab_stats: "Statistiche",
    tab_sources: "Sorgenti",
    tab_promos: "Codici promo",
    tab_affiliates: "Partner",
    tab_commissions: "Commissioni",
    stat_users: "Utenti totali",
    stat_paid: "Utenti paganti",
    stat_mrr: "MRR",
    stat_revenue: "Ricavi totali",
    stat_affiliates: "Partner approvati",
    stat_commissions: "Commissioni in sospeso",
    promos_title: "Codici promo",
    new_promo: "Nuovo codice promo",
    table_code: "Codice",
    table_plan: "Piano",
    table_discount: "Prezzo scontato",
    table_max: "Max usi",
    table_used: "Usati",
    table_active: "Attivo",
    table_actions: "Azioni",
    activate: "Attiva",
    deactivate: "Disattiva",
    delete: "Elimina",
    create_promo_title: "Crea codice promo",
    f_code: "Codice (es. SUMMER25)",
    f_plan: "Piano",
    f_discount: "Prezzo scontato (€)",
    f_max_uses: "Max usi (vuoto = illimitato)",
    f_description: "Descrizione (opzionale)",
    create: "Crea",
    affiliates_title: "Partner",
    af_pending: "Candidature in attesa",
    af_approved: "Partner approvati",
    approve: "Approva",
    reject: "Rifiuta",
    commissions_title: "Commissioni",
    mark_paid: "Segna come pagata",
    no_data: "Nessun dato.",
    tiers_breakdown: "Distribuzione piani",
    col_date: "Data",
    col_affiliate: "Partner",
    col_referred: "Referenziato",
    col_plan: "Piano",
    col_commission: "Commissione",
    col_status: "Stato",
    col_action: "Azione",
    app_company: "Azienda",
    app_web: "Sito",
    app_volume: "Volume",
    app_per_month: "mese",
    promo_created: "Promo creata",
    affiliate_approved: "Partner approvato",
    affiliate_rejected: "Partner rifiutato",
    marked_paid: "Segnata come pagata",
    sources_total_signups: "Iscrizioni totali",
    sources_total_paid: "Iscrizioni paganti",
    sources_total_installs: "Installazioni PWA",
    sources_table_title: "Acquisizione per sorgente",
    sources_table_desc: "Da dove arrivano i tuoi clienti paganti e le installazioni PWA? Usa questi dati per investire sui canali che convertono di più.",
    sources_col_source: "Sorgente",
    sources_col_signups: "Iscrizioni",
    sources_col_paid: "Pagati",
    sources_col_installs: "Installazioni",
    sources_col_conv: "% Pagante",
    sources_empty: "Nessun dato di acquisizione ancora. Le sorgenti appariranno qui non appena gli utenti si iscriveranno o installeranno la PWA.",
    sources_legend: "QR landing = visitatori arrivati dal codice QR sulla landing. Install banner = installazione tramite prompt fluttuante. Direct = nessun parametro di attribuzione.",
    tab_blog: "Blog",
    blog: {
      count_drafts: "Bozze",
      count_published: "Pubblicati",
      count_total: "Totale",
      gen_title: "Genera nuovo articolo con Claude",
      topic_label: "Argomento",
      topic_ph: "Es. Come funziona il rilievo d'ufficio della nullità dopo Cass. SS.UU. 26242/2014",
      keyword_label: "Parola chiave SEO primaria",
      keyword_ph: "Es. nullità contrattuale rilievo d'ufficio",
      locale_label: "Lingua",
      ruling_optional: "Sentenza di riferimento (opzionale)",
      ruling_headline: "Headline / massima",
      ruling_court: "Corte",
      ruling_number: "Numero sentenza",
      ruling_date: "Data (YYYY-MM-DD)",
      ruling_principle: "Principio di diritto",
      generate_btn: "Genera bozza (~30s)",
      generating: "Claude sta scrivendo…",
      gen_success: "Bozza generata. Rivedi e pubblica.",
      gen_error: "Generazione fallita. Riprova.",
      reviewing_draft: "Revisione bozza",
      editing_existing: "Modifica articolo",
      field_title: "Titolo (SEO)",
      field_meta: "Meta description",
      field_keyword: "Parola chiave",
      field_tags: "Tag (separati da virgola)",
      field_hero_url: "URL immagine hero (opzionale)",
      field_body: "Corpo articolo (markdown)",
      save_draft_btn: "Salva come bozza",
      save_publish_btn: "Salva e pubblica",
      discard_btn: "Scarta",
      save_draft_success: "Bozza salvata",
      save_publish_success: "Articolo pubblicato!",
      save_error: "Salvataggio fallito",
      view_live: "Articolo online",
      open: "Apri",
      all_posts: "Tutti gli articoli",
      no_posts: "Nessun articolo ancora. Genera il primo qui sopra.",
      published: "Pubblicato",
      unpublished: "Riportato in bozza",
      deleted: "Articolo eliminato",
      confirm_delete: "Eliminare definitivamente \"{title}\"?",
      action_error: "Operazione fallita",
      err_topic_short: "L'argomento deve avere almeno 5 caratteri",
      err_missing_fields: "Compila titolo, meta description e corpo (minimo 100 caratteri)",
      scheduler_title: "Auto-blog settimanale",
      scheduler_desc: "Ogni lunedì mattina il sistema sceglie una sentenza dalla Banca Dati, genera una bozza con Claude e ti manda un'email per approvarla.",
      next_run: "Prossimo run",
      corpus_used: "Corpus usato",
      recipients: "Destinatari",
      last_run: "Ultimo run",
      run_now_btn: "Esegui ora",
      running_now: "In esecuzione…",
      run_now_success: "Bozza creata dalla sentenza {ruling} e inviata via email.",
      run_now_error: "Esecuzione fallita",
      confirm_run_now: "Vuoi eseguire subito la generazione di una bozza dalla prossima sentenza disponibile? Ci vorranno circa 60 secondi.",
    },
  },
  marketplace: {
    nav: "Marketplace",
    pretitle: "PEER-TO-PEER",
    title: "Il primo marketplace di template legali italiano.",
    subtitle: "Pubblica versioni anonimizzate dei tuoi atti migliori. Guadagna ogni volta che un collega li acquista.",
    cta_browse: "Esplora i template",
    cta_publish: "Pubblica dal mio archivio",
    public_browse_anyone: "L'esplorazione è gratuita per tutti. L'acquisto richiede Legal Pro o Business.",
    search_ph: "Cerca template per titolo, tag o argomento…",
    filter_all_types: "Tutti i tipi",
    sort_recent: "Più recenti",
    sort_popular: "Più venduti",
    sort_price_asc: "Prezzo: basso → alto",
    sort_price_desc: "Prezzo: alto → basso",
    empty_title: "Nessun template ancora",
    empty_body: "Sii il primo a pubblicare — il tuo archivio è pronto e la fee è solo del 15%.",
    card_by: "di",
    card_purchases: "{count} venduti",
    card_buy_cta: "Vedi dettagli",
    price_from: "Da",
    detail_purchases: "Acquisti",
    detail_anon_badge: "Anonimizzato con AI & revisionato dall'autore",
    detail_buy_cta: "Acquista per €{price}",
    detail_buy_locked_cta: "Passa a Legal Pro per acquistare",
    detail_owns_it: "Hai già questo template",
    detail_open_doc: "Apri il documento completo",
    detail_is_author: "Sei l'autore di questo template",
    detail_back: "Torna al marketplace",
    detail_preview_label: "Anteprima (primo paragrafo)",
    detail_locked_hint: "Il documento completo si sblocca dopo l'acquisto.",
    publish_modal_title: "Pubblica nel marketplace",
    publish_step_anonymize: "1. Anonimizza",
    publish_step_review: "2. Rivedi & modifica",
    publish_step_meta: "3. Titolo, prezzo & tag",
    publish_step_publish: "4. Pubblica",
    publish_anonymize_intro: "Claude redarrà ogni nome, indirizzo, codice fiscale, data e importo. La struttura giuridica e le citazioni restano intatte.",
    publish_anonymize_cta: "Anonimizza con AI",
    publish_anonymize_running: "Anonimizzazione in corso… (~20s)",
    publish_anonymized_label: "Testo anonimizzato (modificabile)",
    publish_original_label: "Originale (riferimento)",
    publish_title_label: "Titolo pubblico *",
    publish_title_ph: "Es. Memoria difensiva clausola vessatoria foro consumatore",
    publish_desc_label: "Descrizione *",
    publish_desc_ph: "Spiega il contesto giuridico, a chi è utile e cosa è incluso…",
    publish_tags_label: "Tag (separati da virgola, max 10)",
    publish_tags_ph: "consumatore, foro, clausole vessatorie, 1341 cc",
    publish_category_label: "Categoria",
    publish_category_ph: "civile, lavoro, tributario…",
    publish_price_label: "Prezzo *",
    publish_price_hint: "NEURACOM trattiene il 15%. Guadagni €{author_share} per ogni vendita.",
    publish_save_draft: "Salva bozza",
    publish_publish: "Pubblica ora",
    publish_remove: "Rimuovi dal marketplace",
    publish_drafts_title: "Bozze e pubblicati",
    publish_status_draft: "Bozza",
    publish_status_published: "Live",
    publish_status_removed: "Rimosso",
    publish_open_archive_cta: "Scegli un atto dal tuo archivio",
    publish_empty_archive_cta: "Genera il tuo primo atto",
    toast_anonymized: "Anonimizzazione AI completata — rivedi e modifica se necessario",
    toast_template_created: "Template creato come bozza",
    toast_template_updated: "Template aggiornato",
    toast_template_published: "Template ora live nel marketplace",
    toast_template_removed: "Template rimosso",
    err_anonymize: "Anonimizzazione fallita — riprova",
    err_create: "Impossibile creare il template",
    err_publish: "Impossibile pubblicare il template",
    err_invalid_price: "Fascia di prezzo non valida",
    sales_title: "Le mie vendite",
    sales_balance_label: "Saldo disponibile",
    sales_lifetime_label: "Ricavi totali",
    sales_sales_label: "Vendite",
    sales_paid_out_label: "Già pagato",
    sales_payout_threshold: "Soglia payout: €{threshold}",
    sales_payout_cta: "Richiedi payout",
    sales_payout_below: "Raggiungi €{threshold} per richiedere il payout.",
    sales_payout_pending: "Una richiesta di payout è già in attesa",
    sales_payout_modal_title: "Richiedi payout",
    sales_payout_iban_label: "IBAN",
    sales_payout_iban_ph: "IT60 X054 2811 1010 0000 0123 456",
    sales_payout_notes_label: "Note per il team NEURACOM (opzionale)",
    sales_payout_submit: "Conferma richiesta payout",
    sales_payout_success: "Payout richiesto. NEURACOM elaborerà entro 3 giorni lavorativi.",
    sales_recent_title: "Vendite recenti",
    sales_payouts_title: "Storico payout",
    sales_no_sales: "Nessuna vendita ancora — pubblica un template per iniziare a guadagnare.",
    library_title: "I miei template acquistati",
    library_empty: "Nessun acquisto. Esplora il marketplace per trovare template adatti alla tua materia.",
    library_open: "Apri",
    success_title: "Acquisto completato!",
    success_body: "Il template è sbloccato nella tua libreria.",
    success_cta_library: "Apri la mia libreria",
    success_cta_marketplace: "Torna al marketplace",
    success_polling: "Conferma il pagamento…",
    upgrade_cta_buy: "Diventa Legal Pro per acquistare template",
  },
  publish_from_atti: {
    button: "Pubblica nel marketplace",
    helper: "Guadagna ogni volta che un collega acquista questo template.",
  },
  seo: {
    landing_title: "NEURACOM by TelcaVoIP — Piattaforma AI per aziende e avvocati europei",
    landing_description: "Workspace AI GDPR-compliant per team europei: chat multi-modello, immagini, voice, code builder, analisi documenti. Legal Pro per avvocati italiani con 103 sentenze Cassazione/CGUE, generatore atti e marketplace.",
    pricing_title: "Prezzi — NEURACOM by TelcaVoIP · da gratuito a €149/mese",
    pricing_description: "Piani mensili trasparenti da free a €149 Legal Pro. GDPR-compliant, hosted in UE. Include chat, immagini, voce, codice, giurisprudenza, Atto Generator e accesso marketplace.",
    marketplace_title: "Marketplace Template Legali — Atti italiani generati con AI",
    marketplace_description: "Compra o pubblica template legali anonimizzati da avvocati italiani. Memoria difensiva, ricorsi Cassazione, pareri, diffide, recessi. Da €19. Anonimizzazione AI + revisione dell'autore.",
    jurisprudence_title: "Giurisprudenza Italiana ed Europea — 103 sentenze Cassazione + CGUE",
    jurisprudence_description: "Database ricercabile a testo libero di 103 massime curate di Cassazione italiana e Corte di Giustizia UE. Riforma Cartabia, Codice del Consumo, GDPR, lavoro, contratti.",
  },
  blog: {
    seo_title: "Blog NEURACOM — Cassazione, GDPR, Legal AI e workflow per avvocati",
    seo_description: "Analisi giuridiche, sentenze commentate e guide pratiche per avvocati italiani. Cassazione, CGUE, GDPR, contratti, Legal Pro workflow. Aggiornato ogni settimana.",
    pretitle: "MAGAZINE LEGALE",
    title: "Analisi, sentenze e guide per lo studio moderno.",
    subtitle: "Commenti a sentenze, guide pratiche su GDPR e contratti, workflow AI per avvocati. Contenuti curati da NEURACOM by TelcaVoIP.",
    search_ph: "Cerca articoli…",
    filter_all: "Tutti",
    read_more: "Leggi articolo",
    empty_title: "Nessun articolo trovato",
    empty_body: "Torna presto: pubblichiamo nuove analisi ogni settimana.",
    article_singular: "articolo",
    article_plural: "articoli",
    notfound_title: "Articolo non trovato",
    notfound_body: "L'articolo che cerchi non esiste o non è più pubblicato.",
    back_to_index: "Torna al blog",
    related_title: "Continua a leggere",
    cta_pretitle: "PRUOVA NEURACOM LEGAL PRO",
    cta_title: "AI + Giurisprudenza + Atto Generator per il tuo studio.",
    cta_body: "Claude Opus 4.8, 103 sentenze Cassazione/CGUE indicizzate, generatore atti in italiano forense, Knowledge Base personale. GDPR-compliant, hosted in UE.",
    cta_button_pricing: "Vedi Legal Pro (€149/mese)",
    cta_button_jurisprudence: "Esplora la giurisprudenza",
  },
};

export default it;
